<!--
* @Description: 弃用例题页面
* @Author: shuowang13
* @Date: 2024-08-14
* @LastEditTime: 2024-08-14
* @LastEditors: shuowang13
-->
`
<template>
  <div class="page-main">
    <testHeader :testType="computedTestType" :currentLevelIndex="computedLevelIndex"></testHeader>
    <div class="table-total">
      <el-table
        :data="upgradeResourceList"
        :span-method="objectSpanMethod"
        :header-cell-style="discountHeaderStyle"
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column header-align="center" align="center" width="90">
          <template slot-scope="scope">
            <SvgIcon :type="`${scope.row.name}ing`" class="icon"></SvgIcon>
          </template>
        </el-table-column>
        <el-table-column :label="$t('hsk_practice_part')" header-align="left" align="left">
          <template slot-scope="scope">
            <div>
              {{ JSON.parse(scope.row.part_name_trans)[computedLanguage] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="questionCount"
          :label="$t('hsk_question_number')"
          header-align="left"
          align="left"
        >
        </el-table-column>
        <el-table-column
          :label="$t('evaluate_common_total_score')"
          header-align="left"
          align="left"
        >
          <template slot-scope="scope">
            {{
              scope.row.practiced
                ? Object.values(MARK_RESULT_TYPE).includes(scope.row.question_type)
                  ? 'n/a'
                  : scope.row.score_total
                : '-'
            }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('hsk_test_rate')" header-align="left" align="left">
          <template slot-scope="scope">
            {{ `${(scope.row.part_rate * 100).toFixed(1)}%` }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('hsk_right_rate')" header-align="left" align="left">
          <template slot-scope="scope">
            <div class="progress-content">
              <el-progress
                type="circle"
                :percentage="scope.row.correct_rate * 100"
                :width="20"
                :color="scope.row.correct_rate * 100 >= 60 ? '#62C1A5' : '#FF858C'"
                :stroke-width="3"
                :show-text="false"
              ></el-progress>
              <span>
                {{
                  scope.row.practiced
                    ? Object.values(MARK_RESULT_TYPE).includes(scope.row.question_type)
                      ? 'n/a'
                      : `${(scope.row.correct_rate * 100).toFixed(1)}%`
                    : '--'
                }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('hsk_operation')" header-align="left" align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.practiced" class="practiced">
              <div style="padding-top: 4px" @click="seeResult(scope.row.name, scope.row.partCode)">
                {{ $t('test_has_practiced') }}
              </div>
              <SvgIcon type="arrow-right" class="icon-18"></SvgIcon>
            </div>
            <div v-else class="practice" @click="goPractice(scope.row.name, scope.row.partCode)">
              {{ $t('hsk_practice_go') }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hsk-tips">{{ $t('hsk_link_tips') }}</div>
    <Toolbar justifyContent="center">
      <button class="btn-yellow btn-submit" @click="jumpTest()">
        {{ $t('hsk_link_test') }}
      </button>
    </Toolbar>
  </div>
</template>

<script>
import testHeader from '@/components/hsk/common/testHeader.vue'
import { Table, TableColumn } from 'element-ui'
import SvgIcon from '@/components/SvgIcon.vue'
import { testConfig } from '@/config'
import { apiRequest } from '@/serves/http'
import { mapState, mapGetters } from 'vuex'
import analytics from '@/utils/AnalyticsCenter'
import { MARK_RESULT_TYPE } from '@/config'
import { mixinMixpanel } from '@/mixins'

export default {
  components: {
    testHeader,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    SvgIcon,
  },
  mixins: [mixinMixpanel],
  data() {
    return {
      upgradeResourceList: [],
      //用于计算table合并行
      segments: [],
      MARK_RESULT_TYPE: MARK_RESULT_TYPE,
    }
  },
  watch: {
    levelActive: {
      handler() {
        this.getSpecialData()
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState({
      levelList: (state) => state.level.levelList,
      levelActive: (state) => state.level.levelActive,
      levelType: (state) => state.level.levelType,
      levelActiveIndex: (state) => state.level.levelActiveIndex,
    }),
    ...mapGetters('level', {
      // 获取考试类型
      typeName: 'levelActiveObj',
      levelTypeName: 'levelTypeName',
    }),
    computedTestType() {
      return Number(this.levelType || localStorage.getItem('LevelType'))
    },
    computedTestTypeDesc() {
      const compare = (a, b) => a == b
      return Object.keys(testConfig).find((item) =>
        compare(testConfig[item], this.computedTestType)
      )
    },
    computedLevelId() {
      return Number(this.levelActive || localStorage.getItem('LevelActive'))
    },
    computedLevelIndex() {
      return Number(this.levelActiveIndex || localStorage.getItem('LevelActiveId'))
    },
    computedLanguage() {
      return localStorage.getItem('language')
    },
  },
  methods: {
    // 合并行
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const arr = this.getSpan(this.upgradeResourceList)
        const row = arr[rowIndex].row
        const col = arr[rowIndex].col
        return {
          rowspan: row,
          colspan: col,
        }
      }
    },
    // 隐藏掉不需要的表头
    discountHeaderStyle({ rowIndex }) {
      if (rowIndex == 1) {
        return { display: 'none' }
      } else {
        return { background: '#FAFAFB', border: 'none', fontSize: '12px', color: '#B5B5BE' }
      }
    },
    //环节code一致的分组合并
    getSpecialData() {
      apiRequest
        .post(
          ApiPath.hsk_practice_prepare,
          {
            level_id: this.computedLevelId,
          },
          {
            loading: true,
          }
        )
        .then((res) => {
          this.upgradeResourceList = []
          let partList = res.data.segments || []
          //样题浏览埋点
          let mixpanelParams = {
            people_id: this.peopleId,
            unlimited: this.unlimited,
            exam_type: this.typeName.level_name,
          }
          analytics.logEvent('hskweb_sample_view', mixpanelParams)
          for (let i = 0; i < partList.length; i++) {
            for (let j = 0; j < partList[i].parts.length; j++) {
              this.upgradeResourceList.push({
                ...partList[i].parts[j],
                name: partList[i].segmentCode,
              })
            }
          }
        })
    },
    // 合并行
    getSpan(list) {
      const newArr = []
      const obj = {}
      for (let i = 0; i < list.length; i++) {
        if (i === 0) {
          obj.row = 1
          obj.col = 1
          newArr.push(obj)
        } else {
          if (list[i].name === list[i - 1].name) {
            newArr.push({ row: 0, col: 0 })
            const index = list.findIndex((item) => {
              return item.name === list[i - 1].name
            })
            newArr[index].row++
          } else {
            newArr.push({ row: 1, col: 1 })
          }
        }
      }
      return newArr
    },
    // 去练习
    goPractice(name, id) {
      //hskweb_sampletry_click埋点
      let mixpanelParams = {
        people_id: this.peopleId,
        exam_type: this.typeName.level_name,
        section: name == 'write' ? 'writing' : name + 'ing',
        part: id,
      }
      analytics.logEvent('hskweb_sampletry_click', mixpanelParams)
      utilV2.postData(
        ApiPath.hsk_init_practise,
        {
          level: this.computedTestTypeDesc + Number(this.computedLevelIndex),
          segment: name,
          part: id,
        },
        (data) => {
          this.getUpgradeResourceData(
            data.resourceUrl,
            name,
            id - 1,
            data.paperId,
            false,
            this.computedLevelIndex + 1
          )
        }
      )
    },
    getUpgradeResourceData(resourceUrl, name, id, paperId, ifCheckRecord, level, examinationId) {
      utilV2.getJSON(`${resourceUrl.slice(0, -4)}/index.json`, (data) => {
        this.resourceList = []
        // 重新组装索引页数据
        let tempArr = []
        let Data = []
        for (let i = 0; i < data.items.length; i++) {
          if (tempArr.indexOf(data.items[i].segment_code) === -1) {
            Data.push({
              name: data.items[i].segment_code,
              nameStr: this.findSegmentCodeStr(data.items[i].segment_code),
              dataInfo: [data.items[i]],
            })
            tempArr.push(data.items[i].segment_code)
          } else {
            for (let j = 0; j < Data.length; j++) {
              if (Data[j].name == data.items[i].segment_code) {
                Data[j].dataInfo.push(data.items[i])
                break
              }
            }
          }
        }
        // 取出所有题型的题目 再次重新拼凑
        let quesList = []
        Data.forEach((itemData) => {
          itemData.dataInfo.forEach((data) => {
            quesList.push(this.apiRequest(data.topic_items, resourceUrl))
          })
        })
        Promise.all(quesList).then((res) => {
          let i = 0
          Data.forEach((text) => {
            let typeList = []
            text.dataInfo.forEach((data) => {
              //  套题获取逻辑修改
              let fnlData = []
              //两种题型在同一部分时，bigIndex不置空
              if (typeList.indexOf(data.part_code) === -1) {
                typeList.push(data.part_code)
                this.bigIndex = 0
              }
              res[i]
                .filter((data) => !data.is_example)
                .forEach((item) => {
                  if (item.questions) {
                    this.bigIndex++
                    // 如果是套题的情况
                    let quesGroupist = JSON.parse(JSON.stringify(item.questions))
                    item.questions.forEach((g, index) => {
                      g.topic_type = data.topic_type
                      g.questions = quesGroupist
                      g.part_code = data.part_code
                      g.segment_code = data.segment_code
                      g.ifGroup = true // 是否套题
                      g.num = item.questions.length - index // 当前套题剩余题数量(用于正向下一题使用)
                      g.nnum = index + 1 // 当前套题剩余题数量(用于反向上一题使用)
                      g.bigIndex = this.bigIndex
                      g.top_listen = item.listen
                      g.top_screen_text = item.screen_text
                      item.config && g.config && Object.assign(g.config, item.config)
                      fnlData.push(g)
                    })
                    this.bigIndex += item.questions.length - 1
                  } else {
                    this.bigIndex++
                    item.topic_type = data.topic_type
                    item.part_code = data.part_code
                    item.segment_code = data.segment_code
                    item.ifGroup = false
                    item.num = 1
                    item.nnum = 1
                    item.bigIndex = this.bigIndex
                    fnlData.push(item)
                  }
                })
              i++
              data.questionList = fnlData
            })
          })
          this.upgradeDataList = Data
          this.upgradeDataList.forEach((item) => {
            item.dataInfo = this.apartPartData(item.dataInfo)
          })
          console.log('排查问题用', this.upgradeDataList)
          let jsonObj = this.upgradeDataList.find((item) => {
            return item.name == name
          })
          let json = jsonObj.dataInfo[id]
          console.log(json)
          if (!json.questionList[0].questions) {
            json.questionList = json.questionList.filter((item) => {
              return !item.is_example
            })
          }
          if (!ifCheckRecord) {
            let params = {
              jsonData: { ...json },
              answerNotesArray: [],
            }
            localStorage.setItem('practiceJson', JSON.stringify(params))
            //跳转答题
            this.$router.push({
              name: 'ExaminationUpgrade',
              query: {
                root_path: resourceUrl.slice(0, -4) + '/',
                paperId: paperId,
                level: level,
                part: id + 1,
                exam_type: this.typeName.level_name,
                section: name == 'write' ? 'writing' : name + 'ing',
              },
            })
          } else {
            //跳转查看记录
            utilV2.getData(
              ApiPath.hsk_practise_answer,
              {
                examinationId,
              },
              (data) => {
                this.answerNotesArray = data.questionAnswers
                // 得到记录合并对象
                if (this.answerNotesArray.length) {
                  let filterQuestionList = json.questionList.filter((item) => {
                    return !item.is_example
                  })
                  filterQuestionList.forEach((eg, egIndex) => {
                    this.answerNotesArray[egIndex].nnum = eg.nnum
                    this.answerNotesArray[egIndex].num = eg.num
                    this.answerNotesArray[egIndex].ifGroup = eg.ifGroup
                    Object.assign(eg, this.answerNotesArray[egIndex])
                  })
                }

                console.log('json=====', json)
                let params = {
                  jsonData: { ...json },
                  answerNotesArray: this.answerNotesArray,
                }
                localStorage.setItem('practiceJson', JSON.stringify(params))
                this.dialogPracticeTableVisible = false
                this.$router.push({
                  name: 'ExaminationUpgrade',
                  query: {
                    root_path: resourceUrl.slice(0, -4) + '/',
                    paperId: paperId,
                    currentQuesIndex: 1,
                    paperStatus: 1,
                    report: true,
                    level: level,
                    ifRecord: true,
                  },
                })
              }
            )
          }
        })
      })
    },
    apartPartData(list) {
      let typeList = [] //定义空数组，用于装载去重之后的数组，
      let returnList = [] //返回的数组
      if (list) {
        //如果有值
        list.forEach((item, index) => {
          //可以用indexOf()数组去重 如果检索的结果匹配到,则返回 1. 如果检索的结果没有匹配值,则返回 -1.
          if (typeList.indexOf(item.part_code) === -1) {
            typeList.push(item.part_code)
            this.$set(returnList, index, item)
          } else {
            this.$set(returnList, index - 1, {
              ...returnList[index - 1],
              questionList: returnList[index - 1].questionList.concat(item.questionList),
            })
          }
        })
      }
      return returnList
    },
    findSegmentCodeStr(code) {
      let codeStr = ''
      switch (code) {
        case 'listen':
          codeStr = this.$t('hsk_listen_name')
          break
        case 'read':
          codeStr = this.$t('hsk_read_name')
          break
        case 'write':
          codeStr = this.$t('hsk_write_name')
          break

        default:
          break
      }
      return codeStr
    },
    apiRequest(name, resourceUrl) {
      return new Promise(async (resolve) => {
        let result
        await utilV2.getJSON(`${resourceUrl.slice(0, -4)}/${name}`, (data) => {
          result = data.items
        })
        resolve(result)
      })
    },
    handleCheckRecord(row) {
      this.getUpgradeResourceData(
        row.resourceUrl,
        row.segment,
        row.part - 1,
        row.paperId,
        true,
        this.computedLevelIndex + 1,
        row.examinationId
      )
    },
    seeResult(name, id) {
      utilV2.getData(
        ApiPath.hsk_practise_record,
        {
          level: this.computedTestTypeDesc + this.computedLevelIndex,
          segment: name,
          part: id,
        },
        (data) => {
          this.handleCheckRecord(data[0])
        }
      )
    },
    jumpTest() {
      //hskweb_realpastpaper_click埋点
      let mixpanelParams = {
        people_id: this.peopleId,
        unlimited: this.unlimited,
        exam_type: this.typeName.level_name,
      }
      analytics.logEvent('hskweb_realpastpaper_click', mixpanelParams)
      this.$router.push({
        path: `/${this.levelTypeName || 'hsk'}/index`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.table-total {
  .icon {
    width: 20px;
    height: 20px;
  }
  .practice {
    display: inline-block;
    min-height: 24px;
    background: #fafafb;
    border-radius: 4px;
    color: #2c2f46;
    font-size: 14px;
    padding: 0 15px;
    cursor: pointer;
  }
  .practiced {
    display: flex;
    align-items: center;
    color: #b5b5be;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
  }
  .progress-content {
    display: flex;
    align-items: center;
    span {
      margin-left: 12px;
      color: #2c2f46;
      font-weight: 400;
      font-size: 14px;
    }
  }
}
.btn-submit {
  min-width: 194px;
  height: 44px;
  border-radius: 6px;
  font-size: 18px;
}
.hsk-tips {
  text-align: center;
  margin-top: 20px;
  font-size: 20px;
  font-weight: bold;
}
::v-deep .el-table tbody tr:hover > td {
  background-color: #ffffff !important;
}
</style>
